export default __webpack_public_path__ + "static/3-f078269633bad5b0cbb4fe04848f5633.jpeg";